import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger } from './ui/select';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'fi', label: 'Suomi' },
  { code: 'en', label: 'English' },
  { code: 'cs', label: 'Čeština' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-auto min-w-[70px] px-2 gap-2 bg-transparent border-none shadow-none focus:ring-0 hover:bg-white/10 transition-colors">
        <Globe className="h-5 w-5 text-boho-cream" />
        <span className="font-serif font-bold text-boho-cream">{i18n.language.toUpperCase()}</span>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

